import React, { useState } from 'react'
import App from './App'
import { showFlashMessage } from '../helpers/utils'

export default function DirectorsAccountEmails({ appProps, screenClass, query, accounts, title, description, labels }) {
  const [accountRows, setAccountRows] = useState(accounts)
  const [savingEmailId, setSavingEmailId] = useState(null)

  function search(event) {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const nextQuery = formData.get('query') || ''
    const searchParams = new URLSearchParams()
    if (nextQuery.trim()) searchParams.set('query', nextQuery.trim())

    window.location.href = searchParams.toString()
      ? `${window.location.pathname}?${searchParams.toString()}`
      : window.location.pathname
  }

  function updateEmail(accountId, emailId, updatePath) {
    const account = accountRows.find(row => row.id === accountId)
    const email = account.emails.find(item => item.id === emailId)
    const formData = new FormData()
    formData.append('account_email[email]', email.email)
    formData.append('account_email[primary]', email.primary)

    setSavingEmailId(emailId)

    Rails.ajax({
      type: 'PATCH',
      url: updatePath,
      dataType: 'json',
      data: formData,
      success: res => {
        setAccountRows(accountRows.map(row => row.id === res.account.id ? res.account : row))
        showFlashMessage(labels.saved, 'success')
      },
      error: res => {
        showFlashMessage(res.errors || Cas.translations.error_generic, 'error')
      },
      complete: () => {
        setSavingEmailId(null)
      }
    })
  }

  function updateEmailState(accountId, emailId, attributes) {
    setAccountRows(accountRows.map(account => {
      if (account.id !== accountId) return account

      return {
        ...account,
        emails: account.emails.map(email => email.id === emailId ? { ...email, ...attributes } : email)
      }
    }))
  }

  function renderTenant(tenant) {
    return (
      <div key={ tenant.id } className='director-tenant-row'>
        <div>
          <strong>{ tenant.flavor || '-' }</strong>
          <span>{ tenant.tenantUid }</span>
        </div>
        <div className='director-role'>
          { tenant.role }
          { tenant.platform && <span>{ tenant.platform }</span> }
        </div>
      </div>
    )
  }

  function renderEmail(account, email) {
    return (
      <div key={ email.id } className='director-email-editor'>
        <div className='director-email-editor-heading'>
          <span>{ labels.editEmail }</span>
          <div>
            { email.unconfirmed && <strong>{ labels.unconfirmed }</strong> }
            { email.primary && <strong>{ labels.primary }</strong> }
          </div>
        </div>

        <input
          type='email'
          value={ email.email || '' }
          onChange={ event => updateEmailState(account.id, email.id, { email: event.target.value }) }
        />

        <label className='director-checkbox'>
          <input
            type='checkbox'
            checked={ !!email.primary }
            onChange={ event => updateEmailState(account.id, email.id, { primary: event.target.checked }) }
          />
          <span>{ labels.makePrimary }</span>
        </label>

        <button
          type='button'
          className='button'
          disabled={ savingEmailId === email.id }
          onClick={ () => updateEmail(account.id, email.id, email.updatePath) }>
          { labels.saveAction }
        </button>
      </div>
    )
  }

  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='director-shell'>
          <section className='director-header'>
            <div>
              <span>{ labels.eyebrow }</span>
              <h1>{ title }</h1>
              <p>{ description }</p>
            </div>

            <form className='director-search' onSubmit={ search }>
              <label>{ labels.queryLabel }</label>
              <div>
                <input name='query' type='text' defaultValue={ query } placeholder={ labels.queryPlaceholder } />
                <button className='button' type='submit'>{ labels.searchAction }</button>
              </div>
            </form>
          </section>

          { accountRows.map(account => (
            <section key={ account.id } className='director-email-account'>
              <div className='director-email-account-header'>
                <div>
                  <strong>{ account.fullName || account.uid }</strong>
                  <span>{ labels.uid } { account.uid }</span>
                </div>
              </div>

              <div className='director-email-account-grid'>
                <div className='director-email-editors'>
                  { account.emails.map(email => renderEmail(account, email)) }
                </div>

                <div>
                  <div className='director-section-label'>{ labels.flavorsAndRoles }</div>
                  <div className='director-tenant-list'>
                    { account.tenants.map(renderTenant) }
                  </div>
                </div>
              </div>
            </section>
          )) }

          { query && !accountRows.length && (
            <section className='director-empty-state'>
              { labels.noResults }
            </section>
          ) }
        </div>
      </div>
    </App>
  )
}
